<template>
	<div v-if="$vuetify.breakpoint.lgAndUp">
		<v-menu offset-y close-on-click style="overflow-y: auto !important">
			<template #activator="{ on, attrs }">
				<v-list-item v-bind="attrs" v-on="on">
					<v-list-item-avatar v-if="!avatar" horizontal>
						<v-img :src="no_avatar"></v-img>
					</v-list-item-avatar>
					<v-list-item-avatar v-else horizontal>
						<v-img :src="avatar"></v-img>
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title v-if="user" color="red" :style="`color: ${customColor} !important;`" class="text--secondary font-weight-bold">{{
							usersName
						}}</v-list-item-title>
						<v-list-item-subtitle :style="`color: ${customColor} !important;`">{{ usersProfession }}</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</template>
			<v-card elevation="3" style="overflow-y: hidden !important; overflow-x: hidden !important">
				<v-card-actions>
					<v-row>
						<v-col>
							<v-row class="pb-0 ml-1 mr-1 ma-3"><v-btn :disabled="profileDisabled" router to="/locum/profile" color="secondary" block>Edit Profile</v-btn></v-row>
							<v-row class="pb-0 ml-1 mr-1 ma-3"><v-btn router color="secondary" block @click="openLocumPreview">Preview Profile</v-btn></v-row>

							<v-row class="pb-0 ml-1 mr-1 ma-3"
								><v-btn :disabled="accountDisabled" router to="/locum/account-settings" color="secondary" block>Account Settings</v-btn></v-row
							>
							<v-row class="pb-0 ml-1 mr-1 ma-3"
								><v-btn :loading="apiRequest" router :href="tenant.settings.brandUrl + '/faq'" target="_blank" color="secondary" block>FAQ</v-btn></v-row
							>
							<v-row class="pb-0 ml-1 mr-1 ma-3"
								><v-btn :loading="apiRequest" router :href="tenant.settings.brandUrl + '/blog'" target="_blank" color="secondary" block>Blog</v-btn></v-row
							>
							<v-row class="pb-0 ml-1 mr-1 ma-3"
								><v-btn :loading="apiRequest" router :href="tenant.settings.brandUrl + '/contact'" target="_blank" color="secondary" block>Contact Us</v-btn></v-row
							>
							<v-row class="pb-0 ml-1 mr-1 ma-3"><v-btn :loading="apiRequest" color="secondary" block @click="signOut">Sign Out</v-btn></v-row>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</v-menu>
	</div>
</template>

<script>
import store from '@/store';
import { bus } from '@/main';
import { authSignOut } from '@utils';

export default {
	name: 'LocumNavDrawerDesktop',
	props: {
		customColor: { type: String, default: '#203843' },
		profileDisabled: { type: Boolean, default: false },
		accountDisabled: { type: Boolean, default: false },
	},
	data: () => ({
		user: null,
		first_name: null,
		apiRequest: false,
		no_avatar: require('@/assets/images/avatars/user.png'),
	}),

	computed: {
		usersProfession() {
			if ('profession' in store.getters.user) {
				return store.getters.user.profession;
			} else if ('profile' in store.getters.user) {
				return store.getters.user.industry;
			} else {
				return null;
			}
		},

		usersName() {
			if ('first_name' in store.getters.user) {
				return store.getters.user.first_name;
			} else if ('name' in store.getters.user) {
				return store.getters.user.name;
			} else {
				return null;
			}
		},

		avatar() {
			return store.getters.user.avatar_file;
		},
	},

	created() {
		this.user = store.getters.user;
	},

	methods: {
		async signOut() {
			this.apiRequest = true;
			await authSignOut();
			this.apiRequest = false;
		},
		openLocumPreview() {
			bus.$emit('show-locum-preview-popup');
		},
	},
};
</script>
